module.exports = __webpack_public_path__ + "static/media/warrantyDesactive.87c4c1b7.svg";